{
	"ariaStartSmartCulling": "Start Smart Culling",
	"cullingPreferences": "Culling Preferences"
}
